import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-multi-carousel/lib/styles.css';
import Form from 'react-bootstrap/Form';
import AllChannelsSkeleton from '../components/AllChannelsSkeleton';

import Header from "../components/HeaderFree";
import Footer from "../components/Footer";
//import Loader from "../components/Loader";
import { Link } from 'react-router-dom';

class AllChannelsFree extends Component {
    constructor(props) {
        super(props)
        this.state = {
            contents: [],
            loading: true,
            search: '',
        }
    }
        
    componentDidMount(){
        if(this.state.loading === true){
            fetch(window.backendDomain+'/api/v1/free/contents/channels/all/view', {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json'
                }
            })
            .then(response => response.json())
            .then(json => {
                //console.log(json.data);
                if (json.status === 'OK') {
                    this.setState({contents: json.data});
                    this.setState({loading: false});
                }
            });
        }
    }
    
    render() {   
      return (
        <div>
            <Header />
            <div className="content">
                <div className="mycontainer">
                    { this.state.loading === true ?
                        // <div style={{marginTop: 50}}>
                        //     <Loader />
                        // </div>
                        <AllChannelsSkeleton />
                        :
                        <>
                        {
                            this.state.contents.content[0].status === 1 ?
                            <>
                            <div className="row">
                                <div className="col-12 p-1 pb-4">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h3><Link to='/home/channels'  className="link">Channels</Link> / All</h3>
                                        </div>
                                        <div className="col-md-6">
                                            <Form.Control onChange={(e) => this.setState({search: e.target.value})} size="lg" type="text" placeholder="Search" className="pull-right w-md-50" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                this.state.search === '' ?
                                <div className="row">
                                {
                                    this.state.contents.channelsList.filter( channels => /^\s/.test(channels.name) === false).map((item) => (
                                        <div className="channelDiv p-1">
                                            <Link to={`/home/channel/${item.tag}`}  className="link">
                                                <img src={window.backendUrl+`/${item.logo}`} alt={item.name} className="image" width="100%" />
                                                <div className="col-12 pt-2">
                                                    <center><h6>{item.name}</h6></center>
                                                </div>
                                            </Link>
                                        </div>
                                    ))
                                }
                                </div>
                            :
                            <div className="row">
                                {
                                    this.state.contents.channelsList.filter( channels => /^\s/.test(channels.name) === false && channels.name.toLowerCase().includes((this.state.search).toLowerCase()) ).map((item) => (
                                        <div className="channelDiv p-1">
                                            <Link to={`/home/channel/${item.tag}`}  className="link">
                                                <img src={window.backendUrl+`/${item.logo}`} alt={item.name} className="image" width="100%" />
                                                <div className="col-12 pt-2">
                                                    <center><h6>{item.name}</h6></center>
                                                </div>
                                            </Link>
                                        </div>
                                    ))
                                }
                            </div>
                            }
                            </>
                        :
                            <div className="row">
                                <div className="col-md-6">
                                    <center><h2>Content Not Available!</h2></center>     
                                </div>
                            </div>
                        }
                        </>
                    }
                </div>
            </div>
            <Footer />
        </div>
      );
    }        
}

export default AllChannelsFree
